module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "md-fade-bottom"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopper),
      expression: "showPopper"
    }],
    staticClass: "zk-dropdown-menu"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-0113ec86"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/dropdown/src/dropdown-menu.vue
// module id = 229
// module chunks = 0